





























































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';
import {Editor,CustomDirectEditProvider} from '@/agiles/common/validator';
import { optionFlags } from '../common/flags';

function onCreated(){
    console.log('function.onCreated()');
}

@Component
export default class SubscriptionEditor extends Vue {
  public item: Common.TenantUpdateQuery = null;
  public edittingItem : Common.TenantUpdateQuery = null;
  public payment: Common.PaymentInfoUpdateQuery = null;
  public dialogTenantUpdate: boolean = false;
  public dialogTenantUpdateAfterContract: boolean = false;  // 有償登録後に表示される画面制御用
  public dialogTenantEditing: boolean = true;
  public editor:Editor = new Editor();
  public edittingAmount: number = 0;
  public dialogTenantInvoice: boolean = false;
  public invoiceClosingMinDate: Date = new Date();
  public invoiceClosingMaxDate: Date = new Date();
  public invoiceClosingDate: Date = new Date();
  // public reportTemplateId: number = 0;

  public licenseLight:number = Common.licenseFlags.light;
  public licenseProfessional:number = Common.licenseFlags.professional;

  public get perm(){return 'system.menu_subscription.edit';}
  public get primePerm() { 
    if(this.$api.afterTenantVersion(Common.TenantVersions.Version_241220))
      // 新バージョンより、プロフェッショナルプランの場合は利用プランが変更できるようにする
      return (this.$api.license.isPrime && this.$api.license.licenseFlag != Common.licenseFlags.professional) ? 'prime.menu_subscription.edit' : this.perm;
    else
      return this.$api.license.isPrime ? 'prime.menu_subscription.edit' : this.perm;
    }
  public created() {
    //サインアップURLにコピーボタンを表示
    this.dummyEditor = new Editor();
    this.dummyEditor.owner = new CustomDirectEditProvider();

    //TenantUpdateQueryをロードする
    this.$api.formatter.ensureListLoaded('licenseFlags','optionFlags','templateFlags').then(()=>{
      this.loadTenant();
      this.loadPayment();
    
    });
    // //請求書IDをロードする
    // this.$api.execute(new Common.LoadTenantInvoiceReportIdQuery()).then(res=>{
    //   this.reportTemplateId = res;
    // });
    // サポートプランをロードする
    if(this.$api.license.isTrial == false){
      this.$api.execute(new Common.SupportPlanLoadQuery()).then(res=>{
        this.supportItem = res as Common.SupportPlanData;
        this.hasContract = this.supportItem.supportPlanContracts ? (this.supportItem.supportPlanContracts.length > 0) : false;
      }); 
    }
  }
  public loadTenant() {
    this.$api.execute(new Common.TenantLoadQuery()).then(res => {
      this.item = res;
      this.$api.licenseFlag = res.licenseFlag;
      this.$api.optionFlag = res.optionFlag;
      this.$api.license.hasScannerLicense = res.scannerCount != 0;
      // 請求書出力可能範囲
      this.invoiceClosingMinDate = res.paidStartDate;
      this.invoiceClosingMinDate.setDate(1);
      this.invoiceClosingMaxDate = new Date();
      this.invoiceClosingMaxDate.setDate(1);});
    // サポートプラン更新
    if(this.$api.license.isTrial == false){
      this.$api.execute(new Common.SupportPlanLoadQuery()).then(res=>{
        this.supportItem = res as Common.SupportPlanData;
        this.hasContract = this.supportItem.supportPlanContracts ? (this.supportItem.supportPlanContracts.length > 0) : false;
      }); 
    }
  }
  public loadPayment(){
    this.$api.execute(new Common.PaymentInfoLoadQuery()).then(res => {this.payment = res;});    
  }
  public onCardCreatedPayJP(arg:any){

    var info = new Common.PaymentInfoPayJP();
    info.name = arg.card.name;
    info.brand = arg.card.brand;
    info.last4 = arg.card.last4;
    info.exp_month = arg.card.exp_month;
    info.exp_year = arg.card.exp_year;
    info.token = arg.id;
    info.cvc_check = arg.card.cvc_check;
    //ローカルクエリを使用するとバインド更新されるので別途作成
    var query = new Common.PaymentInfoUpdateQuery();
    query.payJP = info;
    // query.holdPaymentStatus = this.$api.license.isPrime || (this.$api.afterTenantVersion(Common.TenantVersions.Version_241220)==true); //サーバー専有プランか、新バージョンの場合はpaymentStatusは更新しない
    query.holdPaymentStatus = this.$api.isServerExclusive; //サーバー専有プランか、新バージョンの場合はpaymentStatusは更新しない
    this.$api.execute(query).then(res => {
      this.loadPayment();
      // オプションプランの再ロード
      this.$api.formatter.clearList(false, 'optionFlags');
      this.$api.formatter.ensureListLoaded('optionFlags');
    });     

    //ロードマップのクリア
    this.$api.setRoadmapRatio(null);
  }

  //課金開始コンバージョンの発行
  public onCardCreatedPayJP_init(arg:any){
    // バージョンに応じて処理を分岐。新バージョンでは「カード登録」⇒「有償登録」⇒「プラン表示」の流れになる
    if(this.$api.afterTenantVersion(Common.TenantVersions.Version_241220)==true) {
      this.onCardCreatedPayJP_init_v241220(arg);
    }else{
      this.onCardCreatedPayJP(arg);
    }
    //タグマネージャーにイベントを発行
    // var dataLayer = (window as any).dataLayer;
    // if(dataLayer)dataLayer.push({'event': 'billed'});     

    this.$api.issueGA4eventCommon({'event': 'billed'});
  }

  // バージョン241220以降の場合、カード情報登録後に利用プランを表示し、その後有償利用開始とする
  public onCardCreatedPayJP_init_v241220(arg:any){
    this.onCardCreatedPayJP(arg);
    this.edittingItem = this.$api.createBinder(this.item.className).loadInstance(this.item);
    if(this.$api.isServerExclusive)this.dialogTenantEditing = false;
    else this.dialogTenantEditing = true;
    // this.edittingItem.isContract = true;
    this.dialogTenantUpdateAfterContract = true;
    this.dialogTenantUpdate = true;
  }

  public dialogPrimePayment = false
  public paymentAgent : Common.paymentAgents = Common.paymentAgents.payJp; //0:銀行振込 1:PayJP
  
  public showPrimePayment(){
    this.paymentAgent = Common.paymentAgents.payJp;
    this.dialogPrimePayment = true;
  }
  //サーバー専有プランの有償利用を開始
  public execPrimePayment(){
    
    if (this.paymentAgent == Common.paymentAgents.payJp && this.payment.payJP == null){
      this.$api.modal.show("無効な操作","カード情報が登録されていないため、クレジットカードによる有償利用は開始できません。",true,null);
      return;
    } else if (this.paymentAgent == Common.paymentAgents.default && this.payment.payJP != null){
      this.$api.modal.show("無効な操作","カード情報が登録されているため、銀行振込による有償利用は開始できません。",true,null);
      return;      
    }
    var query = new Common.UpdatePaymentStatusQuery();
    query.paymentAgent = this.paymentAgent;

    this.$api.execute(query).then(res => {
      this.loadPayment();
      // オプションプランの再ロード
      this.$api.formatter.clearList(false, 'optionFlags');
      this.$api.formatter.ensureListLoaded('optionFlags');
    });
    //ロードマップのクリア
    this.$api.setRoadmapRatio(null);    
  }

  public showTenantDialog(){
      this.edittingItem = this.$api.createBinder(this.item.className).loadInstance(this.item);
      // 利用プランの表示ボタンはサーバー専有プランの場合s-flowサポートだけが押下可能なので常に設定可
      // if(this.$api.licenseFlag == Common.licenseFlags.prime || this.$api.licenseFlag == Common.licenseFlags.prime2)this.dialogTenantEditing = false;
      // else this.dialogTenantEditing = true;
      this.edittingItem.isContract = false;
      this.dialogTenantUpdate = true;
  }
  public execTenantUpdate(event:any){
    // あんしん導入パックの有効期限内ではライセンスを3未満にできない・電話サポートを追加できない
    if(this.supportItem?.safeIntroductionPackExpiry && this.supportItem.safeIntroductionPackExpiry >= new Date().getCalendarDate())
    {
      if(this.edittingItem.calcMaxLicenseCount < 3) {
        event.preventDefault();
        return this.$api.modal.showDialog('', 'あんしん導入パック期間中は標準ライセンス数を3未満に設定できません。').then(()=>false);
      }
      // 電話サポートはそのまま設定し続けられるよう修正（月締め処理時に導入パック期間を加味するよう変更）
      // if((this.edittingItem.optionFlag & optionFlags.support_phone) > 0) {
      //   event.preventDefault();
      //   return this.$api.modal.showDialog('', 'あんしん導入パック期間中は無料で電話サポートがご利用いただけるので、電話サポートの設定は不要になります。').then(()=>false);
      // }
    }
    if (this.editor.validator.validate()){
      this.$api.execute(this.edittingItem).then(res => {
        if(this.edittingItem.functionFlag == this.$api.functionFlag && this.edittingItem.isContract == false)
          this.loadTenant();
        else
          window.location.reload();
      });
    } else {
      event.preventDefault();
    }
  }

  public showTenantInvoiceDialog(){
    // if(this.reportTemplateId == 0){
    //   return this.$api.modal.showDialog('', '請求書が出力出来ません。 お手数ですがサポートへお問合せ下さい。').then(()=>false);
    // }
    this.invoiceClosingDate = new Date();
    this.invoiceClosingDate.setMonth(this.invoiceClosingDate.getMonth() - 1);
    this.invoiceClosingDate.setDate(1);
    this.dialogTenantInvoice = true;
  }
  public execTenantInvoiceDownload(event:any)
  {
    if (this.editor.validator.validate()){
      // 新会社名対応：請求書テンプレートIDを取得してから、それを出力する
      this.$api.execute(new Common.LoadTenantInvoiceReportIdQuery(this.invoiceClosingDate)).then(res=>{
        var query: Common.TenantInvoiceReportQuery = new Common.TenantInvoiceReportQuery();
        // クエリの設定
        query.closingDate = this.invoiceClosingDate;
        query.templateId = res;
        // query.templateId = this.reportTemplateId;
        this.$api.download(query);
      });
    } else {
      event.cancel();
    }
  }
  

  public execTenantCancel(){
    //解約処理が成功するとログアウトする
    this.$api.modal.showDialog('解約の確認','解約処理とテナントデータの削除を実行します。この操作は取り消すことができません。開始してよろしいですか？',false).then(()=>{
      this.$api.startWaitCusor();
      this.$api.execute(new Common.TenantCancelQuery()).then(res=>{
        this.$api.closeWaitCursor();
        this.$api.auth.logout();
        }); 
    });
  }

  dialogTenantReset :boolean = false;
  generateSampleData: boolean = false;
  provisioningLicenseFlag: number = null;
  provisioningTemplate :string = null;
  public showTenantReset(){
    this.$api.issueGA4event(null, 'テナントの初期化');    
    // 管理者以外は初期化できないよう変更
    if(this.item.adminId != this.$api.auth.userId){
      return this.$api.modal.showDialog('', String.format('初期化はテナントの管理者（管理者名：{0}）のみ実行できます。管理者に連絡するか、「利用プランの変更」より管理者を変更して実行してください。',this.item.adminName,this.item.adminId)).then(()=>false);
    }
    this.provisioningTemplate = this.item.provisioningTemplate;
    this.dialogTenantReset = true;
  }
  public execTenantReset(){
    //リセット処理が成功するとログアウトする
    this.$api.startWaitCusor();
    this.$api.setRoadmapRatio(null);
    this.$api.execute(new Common.TenantResetQuery(this.generateSampleData, this.provisioningTemplate, this.provisioningLicenseFlag)).then(res=>{
      // 利用プランの変更がある場合、変更後環境のリセットクエリをキックする
      if(this.provisioningLicenseFlag){
        this.$api.tenantResetExecute(new Common.TenantResetQuery(this.generateSampleData, this.provisioningTemplate, this.provisioningLicenseFlag)).then(res=>{
          this.$api.closeWaitCursor();      
          this.$api.auth.logout();
        });
      }else{
        this.$api.closeWaitCursor();      
        this.$api.auth.logout();

      }
    });
  }  
  
  // 月額利用料を取得する
  public getMonthlyAmount(item:Common.TenantUpdateQuery){
    // 入力が不正な場合は処理を行わない
    if(item.licenseCount % 1 != 0 || item.storageSize % 1 != 0  || item.scannerCount % 1 != 0) return;
    this.$api.execute(new Common.CalcMonthlyAmountQuery(item)).then(res => {
      this.edittingAmount = res.amount;
    });
  }
  public updateLicenseCount(item:Common.TenantUpdateQuery){
    if(item.calcMaxLicenseCount < 3) item.approveLicenseCount = 0;
    this.getMonthlyAmount(item);
  }

  //******* サポートプラン登録 ******/
  public supportItem : Common.SupportPlanData = null;
  public hasContract: boolean = false;
  public supportPlanUpdate : Common.SupportPlanUpdateQuery;
  public dialogIntroductionPack: boolean = false;
  public supportPlanAmount : number = 0;
  public introductionPackeditor:Editor = new Editor();
  public supportPlanUpdateTelNo : string = '';
  public showIntroductionPackDialog(){
      // ライセンス数が3未満の場合あんしん導入プランの申請はエラー
      if(this.supportItem.contructSafeIntroduction == false && this.item.calcMaxLicenseCount < 3)
      {
        return this.$api.modal.showDialog('', 'あんしん導入パックは標準ライセンス数が3以上のお客様を対象にしております。').then(()=>{return false;}); 
      }
      this.dialogIntroductionPack = true;
      this.supportPlanUpdateTelNo = '';
      this.supportPlanAmount = 0;
      this.supportPlanUpdate = new Common.SupportPlanUpdateQuery(this.supportItem);
      // あんしん導入プランの申込がされていない場合、その申込をする。
      this.supportPlanUpdate.applySafeIntroductionPack = this.supportItem.contructSafeIntroduction==false;
      this.supportPlanUpdate.discountAmount = this.supportItem.discountAmount;
      this.getSupportAmount();
  }
  // サポートプラン料金を計算する
  public getSupportAmount(){
    this.supportPlanAmount = this.supportPlanUpdate.calcAmount()
  }
  public async execSupportPlanUpdate(event:any){
    if (!this.introductionPackeditor.validator.validate()){
      event.preventDefault();
      return;
    }
    // あんしん導入パックの申込
    if(this.supportPlanUpdate.applySafeIntroductionPack == true){
      event.preventDefault();
      // await this.$api.modal.showDialog('確認メッセージ', String.format('あんしん導入パックの申し込みを行います。よろしいですか。\r\n申し込み内容：\r\nあんしん導入パック(一式)    {0} 円(税抜)',this.$api.formatter.formatNumber(this.supportPlanUpdate.calcAmount(),0)), false)
      // .then(() => {
        this.$api.startWaitCusor();
        this.supportPlanUpdate.telNo = this.supportPlanUpdateTelNo;
        this.dialogIntroductionPack = false;
        this.$api.execute(this.supportPlanUpdate).then(res => {
          this.loadTenant();
          this.$api.modal.showDialog('', 'お申し込みありがとうございます。内容については別途メールでご連絡いたします。メールをご確認ください。');
        });
      // });
    }else{
      // 申込がある場合処理を実施
      if(this.supportPlanUpdate.applyAditionalOperationInstruction > 0 || this.supportPlanUpdate.applyAditionalReportSetting > 0)
      {
        event.preventDefault();
    //   let msg = 'あんしん導入パックの追加申し込みを行います。よろしいですか。\r\nお申し込み内容：';
    //   if(this.supportPlanUpdate.applyAditionalOperationInstruction > 0){
    //     msg += String.format('\r\n操作指導(zoom 1時間×{0}回)    {1} 円(税抜)',this.supportPlanUpdate.applyAditionalOperationInstruction,this.$api.formatter.formatNumber(this.supportPlanUpdate.applyAditionalOperationInstruction * this.supportItem.safeIntroductionAditionalOperationInstructionPrice,0));
    //   }
    //   if(this.supportPlanUpdate.applyAditionalReportSetting > 0){
    //     msg += String.format('\r\n帳票テンプレート設定 {0} 帳票  {1} 円(税抜)',this.supportPlanUpdate.applyAditionalReportSetting,this.$api.formatter.formatNumber(this.supportPlanUpdate.applyAditionalReportSetting * this.supportItem.safeIntroductionAditionalReportSettingPrice,0));
    //   }
    // await this.$api.modal.showDialog('確認メッセージ', msg, false)
    //   .then(() => {
          this.$api.startWaitCusor();
          this.dialogIntroductionPack = false;
          this.$api.execute(this.supportPlanUpdate).then(res => {
            this.loadTenant();
            this.$api.modal.showDialog('', 'お申し込みありがとうございます。内容については別途メールでご連絡いたします。メールをご確認ください。');
          });
      // });
      }
    }
  }
    
  //******* サポートパック履歴 ******/
  public showSurvicePackHistory(){
    // ダイアログの表示
    (this.$refs.supportPlanHistory as Components.ListDialog).items = this.supportItem.supportPlanContracts;
    (this.$refs.supportPlanHistory as Components.ListDialog).showDialog();
  }

  //******* クーポン登録 ******/
  public couponEditor:Editor = new Editor();
  public dialogCouponCodeInput:boolean = false;
  public inputCouponCode:string = '';
  public dialogCouponConfirm:boolean = false;
  public needTelNo:boolean = false;
  public couponName:string = '';
  
  public inputCouponCompanyName:string;
  public inputCouponPic:string;
  public inputCouponMail:string;
  public inputCouponTelNo:string = '';


  //******* パートナー登録 ******/
  public dummyEditor: Editor = null;

  public dialogPartnerUpdate:boolean = false;
  public partnerEditor: Editor;
  public partner: Common.PartnerUpdateQuery;
  public isPartnerSignup:boolean = false;
  public partnerConfirm: boolean = false;
  public bankName: string = '';
  public bankCode: string = '';
  public bankBranchName: string = '';
  public bankBranchCode: string = '';
  public bankAccountCategory: number = 0;
  public bankAccountCode: string = '';
  public bankAccountName: string = '';
  public corporateNo: string = '';
  

  public showInputCouponCode(){
    this.dialogCouponCodeInput = true;
  }

  public execCouponCodeCheck(event: any){
    if (this.couponEditor.validator.validate() == false) {
      event.preventDefault();
      return;    
    }
    let query = new Common.CouponCodeCheckQuery(this.inputCouponCode);
    this.$api.execute(query).then(res =>{
      if(res.hasError == true){
        this.$api.modal.showDialog('無効なクーポン',res.errorMessage,true,null).then(()=>{this.dialogCouponCodeInput = true;});
      }else{
        this.couponName = res.couponName;
        this.needTelNo = res.needTelNo;
        this.dialogCouponConfirm = true;
        this.inputCouponCompanyName = res.companyName;
        this.inputCouponPic = res.picName;
        this.inputCouponMail = res.mailAddress;
      }
    });
  }

  public execCouponExecute(event: any){
    if (this.couponEditor.validator.validate() == false) {
      event.preventDefault();
      return;    
    }
    var errorMessage = '';
    if(this.needTelNo)
    {
      if (!errorMessage && !this.inputCouponCompanyName) errorMessage = '会社名 必須項目です。';
      if (!errorMessage && !this.inputCouponPic) errorMessage = 'ご担当者様 必須項目です。';
      // if (!errorMessage && !this.inputCouponMail) errorMessage = 'メールアドレス 必須項目です。';
      if (!errorMessage && !this.inputCouponTelNo) errorMessage = '電話番号 必須項目です。';
      // メールアドレスのチェックがregex指定でできないためここで行う
      // if (!errorMessage && this.inputCouponMail.match("^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$") == null) errorMessage = 'メールアドレスが不正です。';
    }
    if(errorMessage){
      this.$api.modal.showDialog('無効なお客様情報',errorMessage,true,null);
      event.preventDefault();
      return;    
    }
    let query = new Common.CouponExecuteQuery();
    query.couponCode = this.inputCouponCode;
    query.companyName = this.inputCouponCompanyName;
    query.pic = this.inputCouponPic;
    // query.mail = this.inputCouponMail;
    query.telNo = this.inputCouponTelNo;
    this.$api.execute(query).then(res =>{
      this.inputCouponCode = '';
      this.$api.modal.showDialog('','クーポンを反映しました。',true,null).then(()=>{window.location.reload();});
    });
  }


  public showPartnerUpdate(){
    this.partnerEditor = new Editor();
    this.isPartnerSignup = ! this.item.isPartner;
    this.partnerConfirm = false;
    this.partner = new Common.PartnerUpdateQuery();
    if (this.item.isPartner){
      this.bankCode = this.item.bankCode;
      this.bankName = this.item.bankName;
      this.bankBranchCode = this.item.bankBranchCode;
      this.bankBranchName = this.item.bankBranchName;
      this.bankAccountCategory = this.item.bankAccountCategory;
      this.bankAccountCode = this.item.bankAccountCode;
      this.bankAccountName = this.item.bankAccountName;
      this.corporateNo = this.item.corporateNo;
    }
    this.dialogPartnerUpdate = true;
  }
  public execPartnerUpdate(event: any){
    if (this.partnerEditor.validator.validate()){
        this.partner.bankCode = this.bankCode;
        this.partner.bankName = this.bankName;
        this.partner.bankBranchCode = this.bankBranchCode;
        this.partner.bankBranchName = this.bankBranchName;
        this.partner.bankAccountCategory = this.bankAccountCategory;
        this.partner.bankAccountCode = this.bankAccountCode;
        this.partner.bankAccountName = this.bankAccountName;
        this.partner.corporateNo = this.corporateNo;
        this.$api.execute(this.partner).then(res =>{
          this.item = res as Common.TenantUpdateQuery;
          if (this.isPartnerSignup) this.$api.modal.show('導入パートナー','導入パートナー登録が完了しました。サインアップURLが表示されますのでお客様にご案内ください。',true,null);
          else this.$api.modal.show('導入パートナー','入金口座の更新が完了しました。',true,null);
        });
    } else {
      event.preventDefault();
      return;
    }
  }

}
